/* eslint-disable no-sequences */
/* eslint-disable no-unused-vars */
/* eslint-disable no-param-reassign */
/* eslint-disable no-unused-expressions */

import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { defaultReject, defaultState } from "../../../constants";
import { fetchData } from "../../../helpers";

// getReferralRewardDashboard
// GETREFERRALREWARDDASHBOADD
const GETREFERRALREWARDDASHBOADD= createAsyncThunk(
  "getReferralRewardDashboard/getReferralRewardDashboard",
  // eslint-disable-next-line default-param-last
  async (
    // eslint-disable-next-line default-param-last
    payload = {},
    { rejectWithValue }
  ) => {
    try {
      const data = await fetchData(
        payload?.data,
        payload?.method,
        payload?.apiName
      );
      return {
        ...defaultState.List,
        message: data?.data.Message,
        data: data?.data?.data,
      };
    } catch (error) {
      return rejectWithValue({
        ...defaultReject.List,
        message: error.message,
      });
    }
  }
);

// PublishPostSlice
const getReferralRewardDashboardSlice = createSlice({
  name: "getReferralRewardDashboardSlice",
  initialState: {
    getReferralRewardDashboard: {
      ...defaultState.List,
      loading: false, 
      error: false, 
    },
  },
  reducers: {
    setInitialStateOfgetReferralRewardDashboard: (state) => {
        state.getReferralRewardDashboard.loading = false
        state.getReferralRewardDashboard.error = false
        state.getReferralRewardDashboard.data = []
        state.getReferralRewardDashboard.message = ''
      }
  },
  extraReducers: (builder) => {
    builder.addCase(GETREFERRALREWARDDASHBOADD.fulfilled, (state, action) => {
      state.getReferralRewardDashboard = {
        ...state.getReferralRewardDashboard,
        loading: false,
        error: false,
        ...action.payload,
      };
    });
    builder.addCase(GETREFERRALREWARDDASHBOADD.pending, (state, action) => {
      state.getReferralRewardDashboard = {
        ...state.getReferralRewardDashboard,
        loading: true,
        error: false,
        ...action.payload,
      };
    });
    builder.addCase(GETREFERRALREWARDDASHBOADD.rejected, (state, action) => {
      state.getReferralRewardDashboard = {
        ...state.getReferralRewardDashboard,
        loading: false,
        error: true,
        ...action.payload,
      };
    });
  },
});

const getReferralRewardDashboardAction = {
    GETREFERRALREWARDDASHBOADD,
};

export { getReferralRewardDashboardAction };
export default getReferralRewardDashboardSlice.reducer;
export const {setInitialStateOfgetReferralRewardDashboard} = getReferralRewardDashboardSlice.actions